import React from "react";

import { Dropdown } from "semantic-ui-react";

import {
	CLASSIFICATION_CODE_OPTIONS,
	DEFAULT_MAXIMUM_BY_CLASSIFICATION_CODE_TYPE,
} from "globals/constants";

export const ClassificationCodeQuestionTypeSelector = ({ config, onChangeConfig }) => {
	const onCodeTypeChange = codeType => {
		const extraSettings = {
			...config.extraSettings,
			codeType,
			[`${codeType.toLowerCase()}Minimum`]: 1,
			[`${codeType.toLowerCase()}Maximum`]: DEFAULT_MAXIMUM_BY_CLASSIFICATION_CODE_TYPE[codeType],
		};
		onChangeConfig({ extraSettings });
	};

	return (
		<Dropdown
			search
			selection
			options={CLASSIFICATION_CODE_OPTIONS}
			value={config.extraSettings?.codeType}
			onChange={(e, { value }) => onCodeTypeChange(value)}
		/>
	);
};
